<template>
  <div id="app" class="flex-center-container">
    <img id="sojologo" alt="Vue logo" src="./assets/logo.png" />
    <div id="navbar" class="navbar mb-8 mt-4">
      <div>
        <router-link class="m-2" to="/">Giving</router-link>
        <router-link class="m-2" to="/subscriptions">Subscriptions</router-link>
      </div>
    </div>
    <!-- Render a page, when there is one -->
    <template v-if="$route.matched.length">
      <router-view />
    </template>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body {
    @apply bg-black;
    @apply bg-repeat;
}

#sojologo {
  @apply w-3/5;
  @apply max-w-lg;
}

#app {
  @apply font-sans;
  @apply m-8;
  @apply w-11/12;
}

#app > * {
  @apply text-white;
}

</style>
